import { color } from "@smoothincorg/smooth-ui"
import Link from "next/link"
import React from "react"
import { formatDate } from "src/components/List/List"
import { Proposal } from "src/hooks/useProposalSWR"
import { useSmoothApi } from "src/hooks/useSmoothApi"
import { camelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import { V1_OPE_URL } from "src/lib/constants/value"
import { SimplifiedExamination } from "src/pages/admin/lifftter/[proposalId]"
import useSWR from "swr"
// import { useEditingId } from "../../hooks/useEditingId"
import { ModalEditableForm } from "../ModalEditableForm/ModalEditableForm"
import * as styles from "./SimplifiedExaminations.css"
import { sortById } from "../User/User"
import { BorderedButtonAnchor } from "src/components/Button/BorderedButton"

export const SimplifiedExaminations: React.FC<{
  limit?: number
  proposalId: number
}> = ({ proposalId, limit = 100000 }) => {
  const resourceName = `Proposal.${proposalId}.SimplifiedExaminations`
  // const { setEditingId } = useEditingId(`Proposal.${proposalId}.SimplifiedExaminations`)
  const { getWithToken } = useSmoothApi()

  const { data } = useSWR(
    `${SMOOTH_SMOOTHER_API_URL}/proposals/${proposalId}/simplified_examinations`,
    async (url) => {
      const response = await getWithToken(url)
      return response.data["data"].map((d: Proposal) => camelCase(d)) as SimplifiedExamination[]
    }
  )

  const showPageAttributes = [
    "telephoneNumber",
    "familyType",
    "household",
    "incomeYearly",
    "job",
    "jobDescription",
    "companyName",
    "companyNameKana",
    "companyPostalCode",
    "companyAddress",
    "companyTelephoneNumber",
    "rentSubsidy",
    "gardiaResult",
    "numberOfPayment",
    "annualInterestRate",
    "postcode",
    "firstName",
    "lastName",
    "firstFurigana",
    "lastFurigana",
  ] as (keyof SimplifiedExamination)[]

  return (
    <div className={styles.root}>
      <h2 className={styles.title}>
        審査情報（{data?.length || 0}）
        {/* <BorderedButton
          onClick={(e) => {
            e.preventDefault()
            setEditingId((c) => {
              if (c === 0) return null
              return 0
            })
          }}
          style={{ marginLeft: '1rem', background: '#ffffff' }}
        >
          新規作成
        </BorderedButton> */}
        <BorderedButtonAnchor
          href={`${V1_OPE_URL}/admin/simplified_examinations/new?id=${
            sortById(data ?? [])?.[0]?.id
          }`}
          target="_blank"
          style={{
            marginLeft: "1rem",
            background: "#ffffff",
            display: "inline-block",
            fontWeight: "normal",
          }}
        >
          新規作成（前の審査情報を引き継ぐ）
        </BorderedButtonAnchor>
      </h2>
      <section>
        {sortById(data ?? [])
          ?.filter((_, index) => index < limit)
          ?.map((simplifiedExamination, index, array) => {
            const previousSimplifiedExamination = array[index + 1]

            return (
              <div key={simplifiedExamination.id} className={styles.movingApplication}>
                <ModalEditableForm
                  resourceName={resourceName}
                  resource={simplifiedExamination}
                  opeHref={
                    V1_OPE_URL + "/admin/simplified_examinations/" + simplifiedExamination.id
                  }
                  temporary_EDIT_IN_SMOOTHER_OPE_URL={
                    V1_OPE_URL + "/admin/simplified_examinations/" + simplifiedExamination.id
                  }
                  items={[
                    ...showPageAttributes.map((attr) => {
                      const isChangedFromPrevious =
                        previousSimplifiedExamination &&
                        JSON.stringify(previousSimplifiedExamination[attr]) !==
                          JSON.stringify(simplifiedExamination[attr])

                      return [
                        attr,
                        <div key={attr}>
                          <>
                            {simplifiedExamination[attr]}
                            {isChangedFromPrevious && (
                              <span
                                key={attr}
                                style={{
                                  marginLeft: "1rem",
                                  color: color.red,
                                  fontSize: "1.2rem",
                                }}
                              >
                                {`変更前:${previousSimplifiedExamination[attr]}`}
                              </span>
                            )}
                          </>
                        </div>,
                      ] as [string, JSX.Element]
                    }),
                    ["createdAt", formatDate(simplifiedExamination.createdAt)],
                    ["updatedAt", formatDate(simplifiedExamination.updatedAt)],
                  ]}
                  onSubmit={(e) => console.log(e)}
                />
              </div>
            )
          })}

        {data?.length > limit && (
          <Link
            href={`/admin/proposals/${proposalId}/simplified-examinations`}
            style={{
              color: color.main,
              textDecoration: "underline",
              fontSize: "1.4rem",
            }}
          >
            一覧を見る
          </Link>
        )}
      </section>
    </div>
  )
}
